<template>
  <div
    v-if="!fetchingCorsSettings || corsSettings.length"
    class="default-table m-0 border-none shadow-none"
  >
    <b-table
      ref="table"
      class="loaded"
      table-class="m-0 p-0"
      :items="corsSettings"
      :fields="fields"
      :busy="fetchingCorsSettings || addingCorsSettings || deletingCorsSettings"
      responsive
    >
      <template #cell(origin)="data">
        <a
          class="text-primary"
          @click="initEdit(data.item)"
        >
          {{ data.value }}
        </a>
      </template>
      <template #cell(id)="data">
        <div class="d-flex justify-content-end">
          <a @click="initEdit(data.item)">
            <GjIcon name="Edit" />
          </a>
          <a
            style="margin-left:5px;"
            @click="removeCors(data.item)"
          >
            <GjIcon name="Delete" />
          </a>
        </div>
      </template>
    </b-table>
    <div class="px-1 mt-1">
      <a
        class="text-primary text-medium"
        @click="initNew"
      >
        + Add Origin
      </a>
    </div>
    <cors-form
      v-model="corsForm"
      :editing="editing"
      :account-id="accountId"
      @fetchSettings="
        () => {
          fetchCorsSettings()
          corsForm = false
        }
      "
    />
  </div>
  <div
    v-else
    class="text-center p-3"
  >
    <b-spinner />
  </div>
</template>

<script>
import CorsForm from './CorsForm.vue'

export default {
  name: 'Cors',
  components: {
    CorsForm,
  },
  props: {
    accountId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      fields: [
        'origin',
        'allowedMethods',
        'allowedHeaders',
        'exposeHeaders',
        {
          key: 'id',
          label: '',
        },
      ],
      bucketId: null,
      corsForm: false,
      items: [],
      editing: null,
    }
  },
  computed: {
    fetchingCorsSettings() {
      return this.$store.state.accountBucketsCors.fetchingCorsSettings
    },
    addingCorsSettings() {
      return this.$store.state.accountBucketsCors.addingCorsSettings
    },
    deletingCorsSettings() {
      return this.$store.state.accountBucketsCors.deletingCorsSettings
    },
    corsSettings() {
      return this.$store.state.accountBucketsCors.corsSettings
    },
    bucketName() {
      return this.$route.params.id
    },
    accountid() {
      return this.$route.params.accountId
    },
  },
  created() {
    this.bucketId = this.$route.params.id
    this.fetchCorsSettings()
  },
  methods: {
    fetchCorsSettings() {
      const query = {
        accountId: this.accountId,
        bucketName: this.bucketName,
      }

      this.$store
        .dispatch('accountBucketsCors/fetchCorsSettings', query)
        .catch(err => {
          this.errorToast(err.response?.data?.errors[0] || 'Something went wrong while fetching Cors settings!')
        })
    },
    removeCors(val) {
      this.confirmDelete(
        'Remove CORS Origin',
        `Are you sure you want to remove "${val.origin}" ?`,
        'Remove',
      ).then(ok => {
        if (ok) {
          const query = {
            accountId: this.accountId,
            bucketName: this.bucketName,
            corsId: val.id,
          }

          this.$store
            .dispatch('accountBucketsCors/deleteCorsSettings', query)
            .then(() => {
              this.successToast('Cors Origin successfully removed!')
              this.fetchCorsSettings()
            })
            .catch(() => this.errorToast(
              "An error occurred, couldn't delete cors settings.",
            ))
        }
      })
    },
    initCors() {
      this.corsForm = true
    },
    initEdit(item) {
      this.editing = item
      this.corsForm = true
    },
    initNew() {
      this.editing = null
      this.corsForm = true
    },
  },
}
</script>
<style lang="scss" scoped>
.default-table::v-deep {
  margin-bottom: 0;
  .table {
    border-bottom: none;
    tbody {
      tr:nth-child(1) {
        td {
          padding-top: 16px;
        }
      }
      td {
        padding-top: 8px;
        padding-bottom: 8px;
        box-sizing: border-box;
      }
    }
  }
}
</style>
